import { useEffect } from 'react';

interface CssVariable {
  key: string;
  value: string;
}

export const useCssVariables = (cssVars: CssVariable[]) => {
  useEffect(() => {
    cssVars.forEach(({ key, value }) => document.documentElement.style.setProperty(key, value));

    return () => {
      cssVars.forEach(({ key }) => document.documentElement.style.removeProperty(key));
    };
  }, [cssVars]);
};
